// extracted by mini-css-extract-plugin
export default {"shimmer_container":"dashboardCardShimmer_shimmer_container__HOrpT"};